import axios from 'axios';
import { Message } from 'element-ui';
const local = function (url) {
    return new Promise((resolve, reject) => {
        axios({
            url: url, 
            method: 'get'
        })
        .then(function(data){
            resolve(data.data);
        })
        .catch(function(data){
            Message.error('网络异常，请稍后再试!');
        })
    })
    
};

export default local;


// WEBPACK FOOTER //
// ./src/axios/local.js